import React, { useState } from "react";
import { Step } from "semantic-ui-react";
import { initialValuesZero } from "./StepZero.form";
import { initialValuesOne } from "./StepOne.form";
import { StepZero } from "./StepZero";
import { StepOne } from "./StepOne";
import "./MultiStepForm.scss";

export function MultiStepForm({ isUpdateMode, scene, onReload, onClose }) {
  // Solo combinamos los initialValues de los dos pasos
  const mergedInitialValues = {
    ...initialValuesZero(scene),
    ...initialValuesOne(scene),
  };

  const [formData, setFormData] = useState(mergedInitialValues);
  const [step, setStep] = useState(1);

  const nextStep = () => setStep((s) => s + 1);
  const prevStep = () => setStep((s) => s - 1);

  const updateFormData = (newData) =>
    setFormData((prev) => ({ ...prev, ...newData }));

  return (
    <div>
      <div className="step-group-container">
        <Step.Group ordered>
          <Step active={step === 1} completed={step > 1}>
            <Step.Content>
              <Step.Title>Módulo 00</Step.Title>
            </Step.Content>
          </Step>
          <Step active={step === 2} completed={step > 2}>
            <Step.Content>
              <Step.Title>Módulo 01</Step.Title>
            </Step.Content>
          </Step>
        </Step.Group>
      </div>

      {step === 1 && (
        <StepZero
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          isUpdateMode={isUpdateMode}
          scene={scene}
        />
      )}
      {step === 2 && (
        <StepOne
          formData={formData}
          updateFormData={updateFormData}
          prevStep={prevStep}
          isUpdateMode={isUpdateMode}
          scene={scene}
          onReload={onReload}
          onClose={onClose}
        />
      )}
    </div>
  );
}
